/**
 * 日報の項目レベル可視性 (§14-5-5) の語彙。§8-55 対策: 設定画面 (P-8) と入力画面 (P-3) で
 * 同じ概念が違う言葉にならないよう1箇所に集約する。
 * サーバー側の許容値は apps/api/src/lib/daily-report/visibility.ts の as const 配列が正典。
 * 表示段階のラベルは既存 `request-field-visibility-labels.ts` の文言と揃える。
 */
export const DAILY_REPORT_DISPLAY_LEVEL_LABEL: Record<string, string> = {
  none: '表示しない',
  exists_only: '項目名のみ（値は伏せる）',
  full: 'すべて表示',
};

export const DAILY_REPORT_VISIBILITY_CONTEXT_LABEL: Record<string, string> = {
  author: '記入者（自分が書いた日報を見るとき）',
  node_manager: '店舗管理者（店長など）',
  viewer: 'その他の閲覧者',
};
